import type { PlanUnit } from "./types";

/** Unités proposées à l'inspecteur, dans l'ordre d'affichage. */
export const PLAN_UNITS: readonly PlanUnit[] = ["m", "cm", "mm"];
